(function() {
  if (typeof _learnq === "undefined") return;

  // Viewed Product
if (window.kProductData) {
  _learnq.push(["track", "Viewed Product", {
    ProductName: kProductData.title,
    ProductID: kProductData.id,
    Category: kProductData.type,
    Price: kProductData.price,
    ImageURL: kProductData.imageURL,
    SKU: kProductData.sku,
    URL: window.location.href
  }]);
}


  // Viewed Collection
  if (window.kCollectionData) {
    _learnq.push(["track", "Viewed Collection", {
      CollectionName: kCollectionData.title,
      CollectionHandle: kCollectionData.handle,
      URL: window.location.href
    }]);
  }

  // Started Checkout fallback (intent-based)
  document.querySelector('.cart__checkout-button')?.addEventListener('click', function() {
    _learnq.push(["track", "Started Checkout"]);
  });
})();
